import { mainAdminSplitApi } from 'redux/store/mainSplitApi'
import { type ToteSearchResult } from 'types/Tote'

interface ToteSearchParams {
  toteId?: string
  page?: number
  size?: number
  sortBy?: string
  direction?: 'ASC' | 'DESC'
  [key: string]: any
}

const toteApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    searchToteUnits: builder.query<ToteSearchResult, ToteSearchParams>({
      query: ({ toteId, ...params }) => {
        return {
          url: `/totes/${toteId}`,
          params
        }
      },
      providesTags: ['SearchToteUnits']
    })
  })
})

export const { useSearchToteUnitsQuery } = toteApi
